import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '@/store';

export const selectInventoryState = (state: RootState) => state.inventory;

export const selectAllInventoryBatches = createSelector([selectInventoryState], (inventoryState) =>
  inventoryState.allIds.map((id) => inventoryState.byId[id])
);

export const selectInventoryBatchById = (batchId: string) =>
  createSelector([selectInventoryState], (inventoryState) => inventoryState.byId[batchId]);

export const selectFilteredInventoryBatches = createSelector(
  [selectAllInventoryBatches, selectInventoryState],
  (batches, inventoryState) => {
    const { search, warehouseId } = inventoryState.filters;

    return batches.filter((batch) => {
      if (warehouseId && batch.warehouse_id !== warehouseId) return false;
      if (search) {
        const searchLower = search.toLowerCase();
        const matchesSearch = batch.batch_number.toLowerCase().includes(searchLower);
        if (!matchesSearch) return false;
      }
      return true;
    });
  }
);

export const selectInventoryLoading = createSelector(
  [selectInventoryState],
  (inventoryState) => inventoryState.isLoading
);

export const selectInventoryError = createSelector(
  [selectInventoryState],
  (inventoryState) => inventoryState.error
);
